import { useGetSystemSettingQuery } from '../services/nestjs-base-api';
import { useAuth } from './useAuth';

export const useMaturityMode = () => {
    const { user } = useAuth();

    const { data: betaModeData } = useGetSystemSettingQuery(
        { jwtToken: user?.jwtToken || '', settingName: 'BETA_MODE' },
        { skip: !user?.jwtToken }
    );

    const { data: earlyAccessModeData } = useGetSystemSettingQuery(
        { jwtToken: user?.jwtToken || '', settingName: 'EARLY_ACCESS_MODE' },
        { skip: !user?.jwtToken }
    );

    const { data: betaMessageData } = useGetSystemSettingQuery(
        { jwtToken: user?.jwtToken || '', settingName: 'BETA_MESSAGE' },
        { skip: !user?.jwtToken }
    );

    const { data: earlyAccessMessageData } = useGetSystemSettingQuery(
        { jwtToken: user?.jwtToken || '', settingName: 'EARLY_ACCESS_MESSAGE' },
        { skip: !user?.jwtToken }
    );

    // Default to true — set to 'false' in system settings to disable
    const isBetaMode = betaModeData === undefined || betaModeData === 'NOT_FOUND' || betaModeData === 'true' || betaModeData === '1' || (betaModeData as any) === true;
    const isEarlyAccessMode = earlyAccessModeData === undefined || earlyAccessModeData === 'NOT_FOUND' || earlyAccessModeData === 'true' || earlyAccessModeData === '1' || (earlyAccessModeData as any) === true;

    const betaMessage = (betaMessageData && betaMessageData !== 'NOT_FOUND')
        ? betaMessageData
        : 'This feature is currently in beta. Functionality is being refined and may change.';

    const earlyAccessMessage = (earlyAccessMessageData && earlyAccessMessageData !== 'NOT_FOUND')
        ? earlyAccessMessageData
        : 'This feature is in early access. It may have limited functionality as we continue development.';

    return { isBetaMode, isEarlyAccessMode, betaMessage, earlyAccessMessage };
};
